export default "__VITE_ASSET__PYiuWKIN__"